<template>
<div class="addplain">
  <div class="addplain--header">
    <div class="addplain--header--title">
      <div class="title--cancle" @click="handleToCanCelAddPlainBtn($route.params.routerName)">取消</div>
      <div class="title--text">{{ ($route.params.routerName&&$route.params.modifyTag)?'修改':'新增'}}下一步计划</div>
      <div class="title--complete" @click="handleToSubmitFollowPlain($route.params.routerName,$route.params.id)">
        <template v-if="couldEdit">提交</template>
      </div>
    </div>
  </div>
  <div class="addplain--line"></div>
  <div class="addplain--info">
    <div class="addplain--info--item" @click="handleToPlainGetVisitCustom">
      <div class="item--text">客户名称</div>
      <div class="item--desc">{{cusName?cusName:'点击获取客户名称'}}</div>
      <div class="item--icon iconfont">&#xe62c;</div>
    </div>
    <div class="addplain--info--item" @click="isaddPlainDatePickerShow = true">
      <div class="item--text">计划日期</div>
      <div class="item--desc">{{planTime?planTime:'点击选择日期'}}</div>
      <div class="item--icon iconfont">&#xe62c;</div>
    </div>
    <div class="addplain--info--item">
      <md-textarea-item
        ref="demo0"
        autosize
        clearable
        class="example"
        v-model="remark"
        placeholder="请输入跟进计划"
      />
    </div>
    <div class="addplain--info--person">
      <div class="item--persons--title">提醒人</div>
      <div class="item--persons--desc">
        <div
          class="desc--person"
          v-for="(item,index) in mmRemindStaffList"
          :key="item.actorno+index"
        >{{item.actorname}}</div>
        <div
          class="desc--person desc--person--plus iconfont"
          @click="handleToPlainGetFollowPerson"
        >&#xe602;</div>
      </div>
    </div>
  </div>
  <div class="md-example-child md-example-child-date-picker md-example-child-date-picker-3">
    <md-date-picker
      ref="addPlaindatePicker"
      v-model="isaddPlainDatePickerShow"
      type="custom"
      title="选择计划日期"
      large-radius
      :text-render="addPlaintextRender"
      :custom-types="['yyyy', 'MM','dd']"
      :default-date="addPlaincurrentDate"
      @confirm="addPlainonDatePickerConfirm"
    ></md-date-picker>
  </div>
  <div class="addfollowup--visit" v-if="PlainvisitCustomeFlag">
    <div class="visit--title">
      <div class="visit--title--text">选择客户</div>
    </div>
    <div
      class="visit--item"
      v-for="item in PlainvisitCustomList"
      :key="item.id"
      @click="handleToPlainSelectVisitCustom(item)"
    >
      <div class="visit--item--icon iconfont">&#xe629;</div>
      <div class="visit--item--text">{{item.cusName}}</div>
    </div>
  </div>
  <div class="addfollowup--visit" v-if="PlainFollowPersonFlag">
    <div class="visit--title">
      <div class="visit--title--cancle"></div>
      <div class="visit--title--text">选择提醒人</div>
      <div class="visit--title--cancle" @click="handleToCompletePlainFollowPerson">完成</div>
    </div>
    <div class="visit--person">
      <div
        class="visit--person--content"
        :class="{active:mmPlainStaffTag.includes(item.actorno)}"
        v-for="item in PlainFollowPersonList"
        :key="item.actorno"
        @click="handleToAddPlainFollowPerson(item)"
      >{{item.actorname}}</div>
<!--      {{item.organname}}-{{item.actorname}}-->
    </div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { DatePicker, TextareaItem, ImageViewer } from 'mand-mobile'
import { get, postjson } from '../api/api'
import { getFormEmptyField } from '../tools/common'
import recordPageTime from '../mixin/minin'
export default {
  name: 'AddPlain',
  components: {
    [TextareaItem.name]: TextareaItem,
    [DatePicker.name]: DatePicker,
    [ImageViewer.name]: ImageViewer
  },
  data () {
    return {
      addPlaincurrentDate: new Date(), // 当前时间
      isaddPlainDatePickerShow: false, // 控制日历显示
      planTime: '', // 选择日期的值
      remark: '', // 文本域的内容
      PlainvisitCustomeFlag: false, // 控制拜访客户页面显示
      PlainvisitCustomList: [], // 拜访客户列表
      id: '', // 跟进计划id
      relMatterId: '', // 营销事项id
      certCode: '', // 营销事项客户证件号
      cusName: '', // 营销事项客户名称
      PlainFollowPersonFlag: false, // 控制跟进人页面显示
      PlainFollowPersonList: [], // 所有跟进人列表
      mmPlainStaffTag: [], // 已添加跟进人标识(用作样式控制active)
      mmRemindStaffList: [], // 已选择跟进人
      checkFieldList: [], // 校验表单
      couldEdit: true, // 控制不是改事项创建人、参与人是否可见、可编辑、可添加
      postFlag: true // 控制提交一次之后未返回不能再提交
    }
  },
  beforeMount () {
    const relMatterId = this.$route.params.id
    const certCode = this.$route.params.certCode
    const cusName = this.$route.params.cusName
    if (relMatterId && certCode && cusName) {
      this.relMatterId = relMatterId
      this.certCode = certCode
      this.cusName = cusName
    }
    if (this.$route.params.item) {
      this.handleToModifyFollowPlainData(this.$route.params.item)
    } else {
      // 添加登陆人到项目成员
      this.handleToItemPerson()
    }
  },
  methods: {
    // 显示日历文本
    addPlaintextRender () {
      const args = Array.prototype.slice.call(arguments)
      const typeFormat = args[0] // 类型
      const column2Value = args[3] // 第3列选中值
      if (typeFormat === 'dd') {
        return `${column2Value}日`
      }
    },
    // 选择日期
    addPlainonDatePickerConfirm (columnsValue) {
      this.planTime = this.$refs.addPlaindatePicker.getFormatDate('yyyy-MM-dd')
    },
    // 添加登陆人到项目成员
    handleToItemPerson () {
      this.mmRemindStaffList.push({
        actorname: this.$cookies.get('actorname'),
        actorno: this.$cookies.get('actorno')
      })
      this.mmPlainStaffTag.push(this.$cookies.get('actorno'))
    },
    // 获取拜访客户
    async handleToPlainGetVisitCustom () {
      const result = await get('/api/CBMS-APP/mmMarketMatter/popList', {})
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.PlainvisitCustomeFlag = true
        this.PlainvisitCustomList = result.data
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 选择拜访客户
    handleToPlainSelectVisitCustom (item) {
      document.body.style.overflow = 'auto'
      this.PlainvisitCustomeFlag = false
      this.certCode = item.certCode
      this.cusName = item.cusName
      this.relMatterId = item.id
    },
    // 获取跟进人
    async handleToPlainGetFollowPerson () {
      const result = await get('/api/CBMS-APP/sUser/listByComBrId', {})
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.PlainFollowPersonFlag = true
        this.PlainFollowPersonList = result.data.records
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 选择跟进人
    handleToAddPlainFollowPerson (itemObj) {
      if (this.mmPlainStaffTag.includes(itemObj.actorno)) {
        this.mmPlainStaffTag.splice(this.mmPlainStaffTag.indexOf(itemObj.actorno), 1)
        this.mmRemindStaffList = this.mmRemindStaffList.filter(item => item.actorno !== itemObj.actorno)
      } else {
        this.mmRemindStaffList.push({
          actorname: itemObj.actorname,
          actorno: itemObj.actorno
        })
        this.mmPlainStaffTag.push(itemObj.actorno)
      }
    },
    // 完成跟进人选择
    handleToCompletePlainFollowPerson () {
      document.body.style.overflow = 'auto'
      this.PlainFollowPersonFlag = false
    },
    // 添加跟进人
    async handleToSubmitFollowPlain (routerName, id) {
      const FPPostData = {
        id: this.id,
        cusName: this.cusName,
        certCode: this.certCode,
        relMatterId: this.relMatterId,
        planTime: this.planTime,
        remark: this.remark,
        mmRemindStaffList: this.mmRemindStaffList
      }
      this.checkFieldList = getFormEmptyField(FPPostData)
      if (this.checkFieldList.length === 0 && this.postFlag) {
        this.postFlag = false
        const result = await postjson('/api/CBMS-APP/mmFollowPlan/add', FPPostData)
        if (result.success) {
          this.$toast.success({
            message: '跟进计划添加成功',
            onClose: () => {
              this.postFlag = true
              if (routerName) {
                this.$router.push({ name: routerName, params: { id } })
              } else {
                this.$router.push('/plain')
              }
            }
          })
        } else {
          this.postFlag = true
          this.$toast.success('跟进计划添加失败')
        }
      } else {
        this.checkFieldList.forEach(item => {
          if (item === 'mmRemindStaffList') {
            this.$toast.success('跟进人未添加')
            return false
          } else {
            this.$toast.success('有内容未填写')
            return false
          }
        })
      }
    },
    // 修改数据
    async handleToModifyFollowPlainData (item) {
      for (const key in item) {
        this[key] = item[key]
      }
    },
    // 取消按钮触发的事件
    handleToCanCelAddPlainBtn (routerName) {
      if (routerName) {
        this.$router.push({ name: routerName, params: { id: this.$route.params.id } })
      } else {
        this.$router.push('/plain')
      }
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.addplain
  position : relative
  width : 100vw
  min-height : 100vh
  background-color : #f7f7f7
  padding-bottom : 64px
  overflow-x : hidden
  overflow-y : scroll
  .addplain--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .addplain--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--cancle
        width : 120px
        padding-left : 16px
        text-align : left
      .title--complete
        width : 120px
        padding-right : 16px
        text-align : right
      .title--text
        flex : 1
        text-align : center
  .addplain--line
    height : 85px
    width : 100vw
  .addplain--info
    .addplain--info--item
      display : flex
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      &:nth-child(1)
        margin-top : 0
      .item--text
        width : 200px
      .item--desc
        flex : 1
        text-align : left
        text-indent : 32px
      .item--radio
        flex : 1
        text-align : right
        &>>>.md-radio
          margin-top : 0
          margin-bottom : 0
      .item--icon
        width : 100px
        text-align : right
        font-size: 34px
      &>>>.md-field-item
        width : 100vw
      &>>>.md-field-item-content:before
        border-bottom : none
    .addplain--info--person
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .item--persons--title
        padding : 0 0 16px 0
        border-bottom : 1px solid #8b8787
      .item--persons--desc
        display : flex
        align-items : center
        padding : 16px 0
        border-bottom : 1px solid #8b8787
        .desc--person
          background-color : #4282e1
          margin-right : 32px
          width : 100px
          height : 100px
          line-height : 100px
          text-align : center
          border-radius : 50%
          color : #ffffff
          font-family: MyriadPro-Regular
          font-size: 28px
          font-weight: normal
          font-stretch: normal
        .desc--person--plus
          font-size : 32px
  .addfollowup--visit
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow-y : scroll
    .visit--title
      display : flex
      background-color : #4282e1
      .visit--title--text
        flex : 1
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .visit--title--cancle
        width : 150px
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
    .visit--item
      display : flex
      align-items : center
      margin : 16px 32px 0 32px
      border-radius : 12px
      font-family: MyriadPro-Regular
      font-size: 28px
      font-weight: normal
      font-stretch: normal
      border : 1px solid #007aff
      color: #333333
      .visit--item--icon
        padding : 16px
        width : 48px
        color: #4282e1
      .visit--item--text
        flex : 1
        padding: 16px
        text-align : center
    .visit--person
      padding : 16px
      width : 100%
      box-sizing : border-box
      display : flex
      flex-wrap : wrap
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .visit--person--content
        width : calc(25% - 16px)
        padding : 16px 0
        margin-top : 16px
        border : 1px solid #979393
        margin-right : 16px
        text-align : center
        border-radius : 12px
        background-color : #F0F0F0
        &:nth-child(4n)
          margin-right : 0
        &.active
          color: #ffffff
          background-color :#7186d3
          border : 1px solid #979393
  &>>>.md-popup-cancel
    font-size : 38px
    padding-left : 28px
  &>>>.md-popup-confirm
    font-size : 38px
    padding-right : 28px
</style>
